export const getProfileFromLocation = () => {
  const { pathname } = window.location;

  const pathArray = pathname.split("/profile/");
  if (pathArray.length > 1) return `/profile/${pathArray[1]}`;

  return "";
};
